const t = (e) => ["url", "text", "openInNewWindow", "nuxt"].every((n) => n in e);
export {
  t as default
};
